import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import BugForm from '../../../../_components/accounts/tester/bugs/BugForm';
import { Notice, PageContainer, PageSection } from '../../../../ui';
import { BugAttachments } from '../../../Cycles/Bugs/BugAttachments';
import { OperationStatus } from '../../../../types/OperationStatus';
import { CycleStatus } from '../../../../types/CycleStatus';
import actions from '../../../../redux/actions';
import config from '../../../../config';
import { getApprovedDevicePrettyName } from '../../../../services/deviceService';
import * as utils from '../../../../util/utils';

const mapStateToProps = (state) => {
  return {
    user: state.user,
    cycles: state.cycles,
    devices: state.devices,
    editBug: state.editBug,
    cycleBugs: state.cycleBugs,
    editBugStatus: state.editBugStatus,
    device: state.resolution.device,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateBug: (cycleId, bugId, bugData) => dispatch(actions.updateBug(cycleId, bugId, bugData)),
    updateEditBug: (editBug) => dispatch(actions.updateEditBug(editBug)),
  };
};

class EdlitBug extends Component<any> {
  public state: any;

  constructor(props) {
    super(props);

    const cycleId = parseInt(props.match.params.cycleId);
    const cycle = props.cycles.find((el) => el.id === cycleId);

    this.state = {
      cycle,
      bugId: parseInt(props.match.params.bugId),
      editBug: {
        ...props.editBug,
      },
      errors: new Set(),
      totalNewFilesSize: 0,
      totalExistingFilesSize: 0,
    };
  }

  componentDidMount() {
    const editBug = this.props.cycleBugs.byCycleId[this.state.cycle.id].find(
      (bug) => bug.id === this.state.bugId
    );
    this.setState({
      editBug: {
        ...editBug,
        imageFiles: [],
        videoFiles: [],
      },
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.editBug.imageFilePaths.length !== this.state.editBug.imageFilePaths.length ||
      prevState.editBug.videoFilePaths.length !== this.state.editBug.videoFilePaths.length
    ) {
      const totalExistingFilesSize = await this.recalculateExistingFilesSize();
      this.setState({ totalExistingFilesSize });
    }

    if (prevProps.editBugStatus.status !== this.props.editBugStatus.status) {
      if (this.props.editBugStatus.status === OperationStatus.success) {
        this.props.history.push(`/account/tester/cycle/${this.state.cycle.id}/bugs`);
      }
    }
  }

  recalculateExistingFilesSize = async (): Promise<number> => {
    let existingFilesSize = 0;

    for (const imageFilePath of this.state.editBug.imageFilePaths) {
      const response = await fetch(imageFilePath, { method: 'HEAD' });
      const size = response.headers.get('Content-Length');
      existingFilesSize += parseInt(size!);
    }

    for (const videoFilePath of this.state.editBug.videoFilePaths) {
      const response = await fetch(videoFilePath, { method: 'HEAD' });
      const size = response.headers.get('Content-Length');
      existingFilesSize += parseInt(size!);
    }

    return existingFilesSize;
  };

  resetErrorState = (event) => {
    const name = event.target.name;
    const errors = new Set(this.state.errors);

    if (errors.has(name)) {
      errors.delete(name);
      this.setState({ errors });
    }
  };

  onInput = (event, data) => {
    const editBug = { ...this.state.editBug };

    editBug[data.name] = data.value;
    this.setState({ editBug });
  };

  validateInput = (event, data) => {
    const errors = new Set(this.state.errors);
    const name = data && data.name ? data.name : event.target.name;
    const value = data && data.value ? data.value : event.target.value;

    if (!value || !value.length) {
      errors.add(name);
    } else {
      errors.delete(name);
    }

    this.setState({ errors });
  };

  onImageUpload = (acceptedImageFiles) => {
    const imageFiles = [...this.state.editBug.imageFiles];

    const totalImagesFileSize = imageFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    const totalVideoFileSize = this.state.editBug.videoFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    let totalNewFilesSize = totalImagesFileSize + totalVideoFileSize;

    for (let file of acceptedImageFiles) {
      totalNewFilesSize += file.size;

      const isImage = utils.isImage(file.name);
      const ext = utils.getFileExtension(file.name);

      file = Object.assign(file, {
        preview: isImage ? URL.createObjectURL(file) : null,
        isImage,
        lowercaseName: file.name.toLowerCase(),
        ext,
      });

      imageFiles.push(file);
    }

    this.setState({
      editBug: {
        ...this.state.editBug,
        imageFiles,
      },
      totalNewFilesSize,
    });
  };

  onUndoImageUpload = (event, data) => {
    event.stopPropagation();

    const imageFiles = [...this.state.editBug.imageFiles].filter(
      (el, i) => i !== parseInt(data['data-index'], 10)
    );

    const totalImagesFileSize = imageFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    const totalVideoFileSize = this.state.editBug.videoFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    let totalNewFilesSize = totalImagesFileSize + totalVideoFileSize;

    this.setState({
      editBug: {
        ...this.state.editBug,
        imageFiles,
      },
      totalNewFilesSize,
    });
  };

  onDeleteImage = (event, data) => {
    const imageFilePaths = [...this.state.editBug.imageFilePaths];
    _.pullAt(imageFilePaths, data['data-index']);

    this.setState({
      editBug: {
        ...this.state.editBug,
        imageFilePaths,
      },
    });
  };

  onVideoUpload = (acceptedVideoFiles) => {
    const videoFiles = [...this.state.editBug.videoFiles];

    const totalImagesFileSize = this.state.editBug.imageFiles.reduce(
      (result: number, file: any) => {
        result += file.size;
        return result;
      },
      0
    );

    const totalVideoFileSize = videoFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    let totalNewFilesSize = totalImagesFileSize + totalVideoFileSize;

    acceptedVideoFiles.forEach((file) => {
      totalNewFilesSize += file.size;

      file = Object.assign(file, {
        preview: URL.createObjectURL(file),
        lowercaseName: file.name.toLowerCase(),
      });

      videoFiles.push(file);
    });

    this.setState({
      editBug: {
        ...this.state.editBug,
        videoFiles,
      },
      totalNewFilesSize,
    });
  };

  onUndoVideoUpload = (event, data) => {
    event.stopPropagation();

    const videoFiles = [...this.state.editBug.videoFiles].filter(
      (el, i) => i !== parseInt(data['data-index'], 10)
    );

    const totalImagesFileSize = this.state.editBug.imageFiles.reduce(
      (result: number, file: any) => {
        result += file.size;
        return result;
      },
      0
    );

    const totalVideoFileSize = videoFiles.reduce((result: number, file: any) => {
      result += file.size;
      return result;
    }, 0);

    let totalNewFilesSize = totalImagesFileSize + totalVideoFileSize;

    this.setState({
      editBug: {
        ...this.state.editBug,
        videoFiles,
      },
      totalNewFilesSize,
    });
  };

  onDeleteVideo = (event, data) => {
    const videoFilePaths = [...this.state.editBug.videoFilePaths];
    _.pullAt(videoFilePaths, data['data-index']);

    this.setState({
      editBug: {
        ...this.state.editBug,
        videoFilePaths,
      },
    });
  };

  onSubmitBugUpdate = () => {
    const editBug = this.state.editBug;

    const bugProps: Record<string, any> = {
      topic: editBug.topic,
      stepsToReproduce: editBug.stepsToReproduce,
      expectedResult: editBug.expectedResult,
      actualResult: editBug.actualResult,
      comment: editBug.comment,
      severity: editBug.severity,
    };

    if (editBug.testPlanStepId) {
      bugProps.testPlanStepId = editBug.testPlanStepId;
    }

    // TODO remove these two once backend is ready
    if (editBug.imageFilePaths) {
      bugProps.imageFilePaths = editBug.imageFilePaths;
    }

    if (editBug.videoFilePaths) {
      bugProps.videoFilePaths = editBug.videoFilePaths;
    }

    const bugData = {
      bugProps,
      files: {
        imageFiles: editBug.imageFiles,
        videoFiles: editBug.videoFiles,
      },
    };

    this.props.updateBug(this.state.cycle.id, this.state.bugId, bugData);
  };

  render() {
    const editBug = this.state.editBug;

    if (!editBug) {
      return null;
    }

    const cycle = this.state.cycle;

    const isCycleCompleted = cycle.status === CycleStatus.Completed;
    const deviceName = getApprovedDevicePrettyName(this.state.cycle.approvedDevice);

    const bugEditProcessing = this.props.editBugStatus.status === OperationStatus.processing;

    const bugWithStep = editBug.testPlanStepId ? true : false;

    const totalFilesSize = this.state.totalNewFilesSize + this.state.totalExistingFilesSize;
    const totalFilesSizeMB = totalFilesSize === 0 ? 0 : (totalFilesSize / 1024 / 1024).toFixed(2);

    const maxAttachmentsSizeMB = config.maxAttachmentsSizeMB;

    const attachmentsAreTooHeavy = totalFilesSizeMB > maxAttachmentsSizeMB;

    const isMobile = this.props.device === 'mobile' || this.props.device === 'mobile-tablet';

    // Stored files can no longer be removed once the cycle is completed
    const existingAttachments = isCycleCompleted ? (
      <BugAttachments imageFilePaths={editBug.imageFilePaths} videoFilePaths={editBug.videoFilePaths} />
    ) : (
      <BugAttachments
        imageFilePaths={editBug.imageFilePaths}
        videoFilePaths={editBug.videoFilePaths}
        onDeleteImage={this.onDeleteImage}
        onDeleteVideo={this.onDeleteVideo}
      />
    );

    return (
      <PageContainer isMobile={isMobile}>
        {isCycleCompleted && (
          <Notice title="This cycle has finished">
            <Link to="/account/tester">Go to dashboard</Link>
          </Notice>
        )}
        <PageSection title={`Edit bug #${editBug.publicId}`} padding={isMobile ? 1.5 : 2.5}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2.5 }}>
            Device: {deviceName}
          </Typography>
          <BugForm
            values={editBug}
            errors={this.state.errors}
            stepFieldsLocked={bugWithStep}
            onChange={(name, value) => this.onInput(null, { name, value })}
            onFocus={(name) => this.resetErrorState({ target: { name } })}
            onBlur={(name, value) => this.validateInput({ target: { name, value } }, { name, value })}
            existingAttachments={existingAttachments}
            imageFiles={editBug.imageFiles}
            videoFiles={editBug.videoFiles}
            onAddImages={(files) => this.onImageUpload(files)}
            onAddVideos={(files) => this.onVideoUpload(files)}
            onRemoveImage={(index) => this.onUndoImageUpload({ stopPropagation() {} }, { 'data-index': index })}
            onRemoveVideo={(index) => this.onUndoVideoUpload({ stopPropagation() {} }, { 'data-index': index })}
            videoMaxSize={75000000}
            totalFilesSizeMB={totalFilesSizeMB}
            maxAttachmentsSizeMB={maxAttachmentsSizeMB}
            attachmentsTooHeavy={attachmentsAreTooHeavy}
            submitLabel="Save changes"
            submitDisabled={bugEditProcessing || attachmentsAreTooHeavy || this.state.errors.size > 0}
            submitting={bugEditProcessing}
            onSubmit={this.onSubmitBugUpdate}
          />
        </PageSection>
      </PageContainer>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EdlitBug));
